import apiUtils from "../utils/api-utils"
import config from "../utils/config"

const axios = apiUtils.createAxiosInstance()

async function getSupportedIntegrations(userId, teamId) {
  return axios.get(
    `${config.REACT_APP_BACKEND_URL}/users/${userId}/teams/${teamId}/supported_integrations`,
  )
}

async function getTeamIntegrations(userId, teamId) {
  return axios.get(`${config.REACT_APP_BACKEND_URL}/users/${userId}/teams/${teamId}/integrations`)
}

async function createDeal(userId, teamId, dealData) {
  return axios.post(
    `${config.REACT_APP_BACKEND_URL}/users/${userId}/teams/${teamId}/deal`,
    dealData,
  )
}

async function testTeamIntegration(userId, teamId, integrationType) {
  return axios.post(
    `${config.REACT_APP_BACKEND_URL}/users/${userId}/teams/${teamId}/integrations/${integrationType}/test`,
  )
}

async function verifyIntegration(userId, teamId, integrationConfig, integrationType) {
  return axios.post(
    `${config.REACT_APP_BACKEND_URL}/users/${userId}/teams/${teamId}/integrations/verify`,
    {
      config: integrationConfig,
      integrationType,
    },
  )
}

async function updateTeamIntegration(userId, teamId, integrationConfig, integrationType) {
  return axios.put(`${config.REACT_APP_BACKEND_URL}/users/${userId}/teams/${teamId}/integrations`, {
    config: integrationConfig,
    integrationType,
  })
}

async function createTeamIntegration(userId, teamId, integrationConfig, integrationType) {
  return axios.post(
    `${config.REACT_APP_BACKEND_URL}/users/${userId}/teams/${teamId}/integrations`,
    {
      config: integrationConfig,
      integrationType,
    },
  )
}

export default {
  getSupportedIntegrations,
  getTeamIntegrations,
  createDeal,
  testTeamIntegration,
  verifyIntegration,
  updateTeamIntegration,
  createTeamIntegration,
}
